import {http} from '~/utils/http'

export function getStaticResourceText(staticPath: string) {
    return http.get<Blob>(`${location.origin}/static${staticPath}`)
        .then(blob => blob.text())
}
